import { createStore } from 'vuex'
import axios from 'axios'
export default createStore({
  state: {
    submitData:{
      zip:'',
      city: '',
      wanneer_opslagruimte_nodig: 'Binnen 1 week',
      email_address: '',
      name: '',
      lname: '',
      phone_number: '',
      commitment: '12',
      storage_size: '24',
      test_furnuture: 'This visitor did not use the calculator',
      source: 'Gamma',
      step: 'quote', //savedlist //quote
      link: '',
      plan: 'Doe het zelf - basic service',
      planPrice: '0',
      travelCostIndex : 0
    },
    detailsEntered: 0,
    mainStep: 0,
    //Flow data
    currentQuote: {
      size: 0,
      price: 0,
      commitment: 0,
      discountTxt: '',
      discountPrice: 0,
      link: ''
    },
    popup: true,
    quotes: [],
    currentStep: 0,
    stepOne: false,
    stepTwo: false,
    stepThree: false,
    instantCalculation: false,
    instantStep: 0,
    calculating: false,
    calculator: false,
    calculatorSize: 0,
    calculatorRounded: 0,
    currentType: 0,
    skip: false,
    customOffer:{
      id: 21,
      i: 2,
      size: 8,
      price: 54,
      type: "Grote Tuinschuur",
      sizeSquare: "3.4",
      sqft: "37.0",
      maxW: "1.15",
      maxH: "2.35",
      maxL: "2.7",
      detail_3: "ca. een kleine studenten studio",
      detail_4 : "ca. een kleine garage",
      boxes: "ca. 60 verhuisdozen",
      containers: "ca. 7 rolcontainers",
      transport: "ca. 75% VW transporter",
      pou: "paar spullen, klein archief",
      premium: 150,
      loading_time: 15,
      loading_time_premium: 30
  },
    appointmentCta:{
      transform: false,
    },
    //calculator
    currentItems: [],
    savedLists: [],
    savedTotals: [],
    savedCalculations: [],
    savedCustoms: [],
    selectedCommitment : 12,
    commitments:[
      {
       title: '1+ maand',
       period: 1, 
       discount: 'Super flexibel',
      },
      {
       title: '3+ maanden',
       period: 3,
       discount: '10%', 
      },
      {
       title: '6+ maanden',
       period: 6,
       discount: '25%', 
      },
      {
       title: '12+ maanden',
       period: 12,
       discount: '40%', 
      },
    ],
    
    currentOffer:{
      id: 21,
      i: 2,
      short: 'XS',
      img: 'xs.png',
      size: 8,
      price: 72,
      type: "Grote Tuinschuur",
      sizeSquare: "3.4",
      sqft: "37.0",
      maxW: "1.15",
      maxH: "2.35",
      maxL: "2.7",
      detail_3: "ca. een kleine studenten studio",
      detail_4 : "ca. een kleine garage",
      boxes: "ca. 60 verhuisdozen",
      containers: "ca. 7 rolcontainers",
      transport: "ca. 75% VW transporter",
      pou: "paar spullen, klein archief",
      premium: 150,
      loading_time: 15,
      loading_time_premium: 30
  },
    //Offers
    travelCosts: [
      {
       name:'Regio Amsterdam (+20km)',
       one: '107.25',
       three: '0',
       six: '0',
       twelve: '0', 
      },
      {
        name:'Regio Haarlem (+20km)',
        one: '108.75',
        three: '0',
        six: '0',
        twelve: '0', 
       },
       {
        name:'Regio Rotterdam (+20km)',
        one: '31.80',
        three: '0',
        six: '0',
        twelve: '0', 
       },
       {
        name:'Regio Den Bosch (+30km)',
        one: '125.70',
        three: '5.70',
        six: '5.70',
        twelve: '5.70', 
       },
       {
        name:'Regio Alkmaar (+20km)',
        one: '146.85',
        three: '26.85',
        six: '26.85',
        twelve: '26.85', 
       },
       {
        name:'Regio Lelystad (+50km)',
        one: '157.50',
        three: '37.50',
        six: '37.50',
        twelve: '37.50', 
       },
       {
        name:'Regio Apeldoorn (+50km)',
        one: '160.50',
        three: '40.50',
        six: '40.50',
        twelve: '40.50', 
       },
       {
        name:'Regio Nijmegen (+30km)',
        one: '166.50',
        three: '46.50',
        six: '46.50',
        twelve: '46.50', 
       },
       {
        name:'Regio Eindhoven (+20km)',
        one: '180',
        three: '60',
        six: '60',
        twelve: '60', 
       },
       {
        name:'Regio Zwolle (+50km)',
        one: '195',
        three: '75',
        six: '75',
        twelve: '75', 
       },
       {
        name:'Regio Hengelo (+50km)',
        one: '253.50',
        three: '133.50',
        six: '133.50',
        twelve: '133.50', 
       },
       {
        name:'Regio Roermond (+30km)',
        one: '258',
        three: '138',
        six: '138',
        twelve: '138', 
       },
       {
        name:'Regio Heerenveen (+50km)',
        one: '262.50',
        three: '142.50',
        six: '142.50',
        twelve: '142.50', 
       },
       {
        name:'Regio Hoogeveen (+50km)',
        one: '265.50',
        three: '145.50',
        six: '145.50',
        twelve: '145.50', 
       },
       {
        name:'Regio Assen (+50km)',
        one: '307.50',
        three: '187.50',
        six: '187.50',
        twelve: '187.50', 
       },
       {
        name:'Regio Heerlen (+50km)',
        one: '312',
        three: '192',
        six: '192',
        twelve: '192', 
       },
       {
        name:'Regio Groningen (+50km)',
        one: '343.50',
        three: '223.50',
        six: '223.50',
        twelve: '223.50', 
       },

    ],
    offers: [
      {
        id: 21,
        i: 2,
        short: 'XS',
        img: 'xs.png',
        size: 8,
        price:72,
        type: "Grote Tuinschuur",
        sizeSquare: "3,4",
        sqft: "37,0",
        maxW: "1,15",
        maxH: "2,35",
        maxL: "2,7",
        boxes: "60",
        containers: "7",
        detail_3: "ca. een grote tuinschuur",
        detail_4 : "ca. een kleine kamer",
        transport: "75% VW transporter",
        pou: "paar spullen, klein archief",
        premium: 150,
        loading_time: 15,
        loading_time_premium: 30,
        copy: "Mini opslag 8m³ is geschikt voor kleine spullen, zoals koffers, verhuisdozen, stoelen, planten, tv, spiegels en lampen. Of juist weinig spullen van een iets groter formaat, zoals een kleine boekenkast, kleine eettafel of kleine bank. Deze opslagruimte is handig voor wanneer je op reis gaat, je studiespullen of thuisarchief wilt opslaan of in een kleine verbouwing of kleine verhuizing zit."
    },
    {
      id: 41,
      i: 4,
      short: 'S',
      img: 's.png',
      size: 12,
      price: 77,
      type: "Kleine Bestelbus",
      sizeSquare: "5,1",
      sqft: "55,0",
      maxW: "1,15",
      maxH: "2,35",
      maxL: "2,7",
      boxes: "90",
      detail_3: "ca. een kleine studenten studio",
      detail_4 : "ca. een kleine garage",
      containers: "11",
      transport: "1,25 VW transporters",
      pou: "thuis extra ruimte, kleine verbouwing, kleine verhuizing",
      premium: 225,
      loading_time: 25,
      loading_time_premium: 50,
      copy: "Small opslag 12m³ is geschikt voor meubels zoals een bed, bank, kledingkast of eettafel en stoelen. Of voor een flinke verzameling aan kleine spullen, zoals koffers, verhuisdozen, archief, fietsen of kampeer- of wintersportspullen. Deze opslagruimte is handig voor wanneer je in een kleine verbouwing of kleine verhuizing zit of thuis of op een klein kantoor wat ruimte tekortkomt."
  },
  {
    id: 101,
    i: 10,
    short: 'M',
    img: 'm.png',
    size: 24,
    price: 144,
    type: "Inbox Citytruck",
    sizeSquare: "10,2",
    sqft: "110,0",
    detail_3: "ca. een apartment met 2 slaapkamers",
    detail_4 : "ca. een kleine rijtjeswoning",
    maxW: "1,15",
    maxH: "2,35",
    maxL: "2,7",
    boxes: "180",
    containers: "22",
    transport: "0,5 VW transporters",
    pou: "kleine voorraad, verbouwing, verhuizing",
    premium: 428,
    loading_time: 50,
    loading_time_premium: 95,
    copy: "Medium opslag 24m³ is geschikt voor meerdere grote meubels zoals bedden, banken, wandkasten en tafels. Of voor een combinatie van meubels en witgoed zoals een wasmachine, wasdroger. Natuurlijk is dit aan te vullen met kleinere spullen, zoals koffers, verhuisdozen, archief of vakantiespullen. Deze opslagruimte is handig voor wanneer je in een kleine verbouwing of kleine verhuizing zit of thuis of op kantoor wat ruimte tekortkomt.",
},
{
  id: 131,
  i: 13,
  short: 'L',
  img: 'l.png',
  size: 30,
  price: 160,
  type: "+/- grote bakwagen",
  sizeSquare: "12,8",
  detail_3: "ca. een twee-onder-een-kap met tuin",
  sqft: "137,0",
  maxW: "1,15",
  maxH: "2,35",
  maxL: "2,7",
  boxes: "225",
  containers: "27",
  transport: "3,25 VW transporters",
  pou: "voorraad, grote verbouwing, verhuizing",
  premium: 540,
  loading_time: 60,
  loading_time_premium: 120,
  copy: "Groot opslag 30m³ is geschikt voor de opslag van een complete inboedel van een woning, zoals een appartement met meerdere slaapkamers Denk aan meerdere banken, tafels, bedden, witgoed en meerdere verhuisdozen met kleine spullen. Deze opslagruimte is handig voor wanneer je in een grote verbouwing of verhuizing zit. Daarnaast is deze unit ook te gebruiken als tijdelijke voorraadopslag voor je bedrijf. Bijvoorbeeld voor wanneer je hard aan het groeien bent en voorraadruimte tekortkomt, aan het verhuizen bent of je magazijn verbouwt.",
},
{
  id: 161,
  i: 16,
  short: 'XL',
  img: 'xl.png',
  size: 36,
  price: 184,
  detail_3: "ca.  een eensgezinswoning met drie slaapkamers",
  type: "+/- 1 gezins woning",
  sizeSquare: "15,3",
  sqft: "165,0",
  maxW: "1,15",
  maxH: "2,35",
  maxL: "2,7",
  boxes: "270",
  containers: "33",
  transport: "4 VW transporters",
  pou: "voorraad, grote verbouwing, grote verhuizing",
  premium: 653,
  loading_time: 75,
  loading_time_premium: 745,
  copy: "Groot opslag 36m³ is geschikt voor de opslag van een complete inboedel van een eengezinswoning, zoals een rijtjeshuis. Denk aan meerdere banken, tafels, een bed en witgoed. Deze opslagruimte is handig voor wanneer je in een verbouwing of verhuizing zit of thuis of op kantoor ruimte tekortkomt. Daarnaast is deze unit ook te gebruiken als tijdelijke voorraadopslag voor je bedrijf. Bijvoorbeeld voor wanneer je hard aan het groeien bent en voorraadruimte tekortkomt, aan het verhuizen bent of je magazijn verbouwt.",
},
{
  id: 221,
  i: 22,
  short: 'XXL',
  img: 'xxl.png',
  size: 48,
  price: 244,
  type: "Grote Garagebox",
  detail_3: "ca. een grote gezinswoning met 5 kamers",
  sizeSquare: "20,4",
  sqft: "220.0",
  maxW: "1,15",
  maxH: "2,35",
  maxL: "2,7",
  boxes: "360",
  containers: "43",
  transport: "5,25 VW transporters",
  pou: "bedrijfsverhuizing",
  premium: 855,
  loading_time: 95,
  loading_time_premium: 190,
  copy: "Groot opslag 46m³ is geschikt voor een grote bedrijfsverhuizing of bedrijfsvoorraad. Denk aan de tijdelijke opslag van meerdere kantoor verdiepingen of kantoortuinen. Of als oplossing voor als je tijdelijk meer opslagruimte nodig hebt voor je voorraad. Door bijvoorbeeld snelle groei, een verhuizing, verbouwing aan je magazijn of een groot tijdelijk project. Daarnaast kun je in deze opslagruimte de complete inboedel van een grotere woning kwijt.",
},
  
    ],
    currentSizeData:{
      size: '',
      lineOne: '',
      lineTwo: '',
      lineThree: '',
      lineFour: '',
      paragraphOne: '',
      paragraphTwo: '',
    },
    firstLead: false,  
  },
  mutations: {
    changeMainStep(state, payload){
      state.mainStep = payload;
  
    },
    editSize(state,size){
      state.submitData.storage_size = size
      for(let i=0; i<state.offers.length;i++)
       if(size == state.offers[i].size)
        state.currentOffer= state.offers[i]
    },
    changeDetailsEntered(state, payload){
      state.detailsEntered = payload;
  
    },
    changeCurrentSizeData(state,payload){
      state.currentSizeData[payload.item] = payload.new
    },
    changeFirstLead(state, payload) {
      state.firstLead = payload;
    },
    //old ones
    changeCurrentStep(state, payload) {
      state.currentStep = payload;
    },
    changeSelectedCommitment(state, payload) {
      state.selectedCommitment = payload;
    },
    changeSubmitData(state,payload){
      state.submitData[payload.item] = payload.new
    },
    changeCurrentQuote(state,payload){
      state.currentQuote[payload.item] = payload.new
    },
    changeInstantCalculation(state,payload){
      state.instantCalculation= payload
    },
    changeCalculating(state,payload){
      state.calculating= payload
    },
    changeCalculatorSize(state,payload){
      state.calculatorSize= payload
    },
    changeCalculatorRounded(state,payload){
      state.calculatorRounded= payload
    },
    changePopup(state,payload){
      state.popup= payload
    },
    completeStep(state,payload){
      state[payload]= true
    },
    changeCalculator(state,payload){
      for (let i=0; i<state.offers.length; i++)
        state.offers[i].transform =false
      state.calculator= payload
    },
    changeCustomOffer(state,payload){
      state.customOffer = state.offers[payload]
      state.customOffer.i=payload
      state.customOffer.transform = false
    },
    resetCalculator(state){
      state.calculatorSize = 0
      state.calculatorRounded = 0
      state.customOffer = state.offers[0]
      for (let i=0; i<state.woonkamer.length; i++)
        state.woonkamer[i].counter =0
      for (let i=0; i<state.keukenEetkamer.length; i++)
        state.keukenEetkamer[i].counter =0
      for (let i=0; i<state.slaapkamer.length; i++)
        state.slaapkamer[i].counter =0
      for (let i=0; i<state.kinderkamer.length; i++)
        state.kinderkamer[i].counter =0
      for (let i=0; i<state.garage.length; i++)
        state.garage[i].counter =0
      for (let i=0; i<state.zakelijk.length; i++)
        state.zakelijk[i].counter =0
      state.totals.woonkamer = 0
      state.totals.keukenEetkamer = 0
      state.totals.slaapkamer = 0
      state.totals.kinderkamer = 0
      state.totals.garage = 0
      state.totals.zakelijk = 0
      state.currentItems = []            
    },
    changeSkip(state, payload){
      state.skip = payload
    },
    appendQuote (state, quote) {
      state.quotes.push(quote);
    },
    removeQuote (state, payload) {
      state.quotes.splice(payload,1)
    },
    appendCurrentItems (state, item) {
      state.currentItems.push(item);
    },
    removeItemFromCurrent (state, payload) {
      state.currentItems.splice(payload,1)
    },
    appendSavedLists (state, list) {
      state.savedLists.push(list);
    },
    appendSavedCalculations(state,calculation){
      state.savedCalculations.push(calculation)
    },
    appendSavedCustoms(state,custom){
      state.savedCustoms.push(custom)
    }
  },
  getters: {
    quotes: state => {
      return state.quotes;
    },
    currentItems: state => {
      return state.currentItems;
    },
    savedLists: state => {
      return state.savedLists;
    },
    savedCalculations: state => {
      return state.savedCalculations;
    },
    savedCustoms: state => {
      return state.savedCalculations;
    },    
  },
  actions: {
    addQuote (state, payload) {
      state.commit('appendQuote', payload);
    },
    addCurrentItems(state, payload){
      state.commit('appendCurrentItems',payload)
    },
    addSavedLists(state, payload){
      state.commit('appendSavedLists',payload)
    },
    addSavedCalculations(state, payload){
      state.commit('appendSavedCalculations',payload)
    },
    addSavedCustoms(state, payload){
      state.commit('appendSavedCustoms',payload)
    },
    async renderZip({ commit }, zip){ //state not working have to implement commit
      const apiUrl = 'https://api.opslagamsterdam.com/api'
      var link = ''
  
      
      commit('changeSubmitData',{item:'zip',new:zip})
      let region = zip.substring(0, zip.length - 2);
      link = apiUrl + '/control/zips/getpost/' + region
      axios.get(link)
          .then((response)=>{     
            let res = response.data[0]
            let city = res.city
            commit('changeSubmitData',{item:'city',new:city})              
          }).catch(error => {
            console.log(error)
            //this.zipError = 'Something went wrong. Please try again';
          });        
  
    },
  },
  modules: {
  }
})
